<template>
  <div class="reserve-index">
    <div class="reserve-header">
      <div class="branch" @click="showSelectBranch = true">
        <span>
          {{ branchName || $t("insOutsText") }}
        </span>
        <van-icon name="arrow-down" />
      </div>
      <div class="reserve-date-counter">
        <div class="reserve-date-list">
          <div
            class="reserve-date-item"
            :class="{ active: formData.dayDate === item.dayDate }"
            v-for="item in options"
            :key="item.dayDate"
            @click="handleChangeDay(item)"
          >
            <div class="reserve-date-item__date">{{ item.dayText }}</div>
            <div class="reserve-date-item__week">{{ item.weekText }}</div>
          </div>
        </div>
        <div
          v-if="options.length"
          class="calendar-main"
          @click="showSelectCalendar = true"
        >
          <van-icon name="notes-o" size="19" />
          <span>{{ $t("calendar") }}</span>
        </div>
      </div>
      <div class="reserve-meal-list">
        <div
          class="reserve-meal-item"
          :class="{ active: item.id === formData.mealHourId }"
          v-for="item in mealConfigList"
          :key="item.id"
          @click="handleChangeMeal(item)"
        >
          <div class="reserve-meal-item__name">
            {{ language == 'CN' ? item.configName : item.configNameEn }}
          </div>
          <div class="reserve-meal-item__time">
            {{ item.startTime.substring(0, 5) }}-{{
              item.endTime.substring(0, 5)
            }}
          </div>
        </div>
      </div>
      <!-- <div class="reserve-group-list" v-show="!hideGroup">
        <div
          class="reserve-group-item"
          :class="{ active: item.id === formData.groupId }"
          v-for="item in groupOptions"
          :key="item.id"
          @click="handleChangeGroup(item)"
        >
          <div class="reserve-group-item__name">{{ item.name }}</div>
        </div>
      </div> -->
    </div>
    <div class="reserve-location-list">
      <div
        class="reserve-location-item"
        v-for="item in renderList"
        :key="item.id"
      >
        <div class="reserve-location-item__pic">
          <img
            :src="item.imgurl"
            v-if="item.imgurl"
            alt=""
            @click="onPreview(item.imgurl)"
          />
        </div>
        <!-- 状态标识 -->
        <div class="reserve-location-item__status">
          {{ language == 'CN' ? item.groupName : item.groupNameEn || item.groupName }}
        </div>

        <div class="reserve-location-item__desc" v-if="item.extraInfo">
          {{ item.extraInfo }}
        </div>
        <!--主要内容 -->
        <div class="reserve-location-item__content">
          <div class="reserve-location-item__name">{{ language == 'CN' ? item.name : item.enName || item.name }}</div>
          <!--  -->
          <div class="reserve-location-item__info">
            <div class="reserve-location-item__info__item__name">
              {{ $t("capacity") }}
            </div>
            <div class="reserve-location-item__info__item__value">
              {{ item.capacity }} {{ $t("capacityUnit") }}
            </div>
          </div>
          <div
            class="reserve-location-item__action"
            :class="{
              disabled: item.roomStatus !== 1,
              cancel_action: cancelReserveShow(item),
            }"
            @click="handleToReserve(item)"
          >

            {{
              cancelReserveShow(item)
                ? $t("reserveStatus6")
                : item.roomStatus === 1
                ? $t("reserveStatus1")
                : $t("reserveStatus2")
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="empty-comp" v-if="isNoData">
      {{ $t("noData") }}
    </div>

    <van-popup
      position="bottom"
      :style="{
        'padding-bottom': '35px',
        height: '100%',
        background: '#f2f2f2',
      }"
      v-model="showSelectBranch"
      :close-on-click-overlay="false"
    >
      <!-- 分店选择 -->
      <SelectBranch
        type="component"
        v-if="showSelectBranch"
        @selected="handleSelectSelectBranch"
        :filter-branch="filterBranch"
        branchType="privateroom"
        :title="$t('insOutsText')"
      />
    </van-popup>
    <!-- 选择日历 -->
    <van-calendar
      v-model="showSelectCalendar"
      color="#1989fa"
      :title="$t('calendarTitle')"
      @confirm="handleConfirmSelectCalendar"
      :show-confirm="false"
      :max-date="maxDate"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import SelectBranch from "../../card/SelectBranch.vue";
import { ImagePreview, Dialog } from "vant";

export default {
  components: {
    SelectBranch,
  },
  data() {
    return {
      hideGroup: false,
      options: [],
      userinfo: {},
      shopId: localStorage.getItem("shopId"),
      formData: {
        dayDate: "",
        mealHourId: "",
      },
      list: [],
      showSelectBranch: false,
      isNoData: false,
      branchId: localStorage.getItem("branchId"),
      branchName: null,
      language: "",
      showSelectCalendar: false,
      mealConfigList: [],
      maxDate: new Date(),
      mealCopyConfigList: [],
    };
  },
  computed: {
    mealOptions() {
      const list =
        (
          this.options.find((item) => item.dayDate === this.formData.dayDate) ||
          {}
        ).mealHourAndRoomGroupList || [];
      return list.map((item) => {
        item.mealText =
          dayjs(item.startTime).format("HH:mm") +
          "-" +
          dayjs(item.endTime).format("HH:mm");
        return item;
      });
    },
    groupOptions() {
      return (
        (
          this.mealOptions.find(
            (item) => item.id === this.formData.mealHourId
          ) || {}
        ).groupList || []
      );
    },
    renderList() {
      return this.list || [];
    },
    cancelReserveShow() {
      return (row) => {
        return (
          row.reserveRecordForm &&
          row.reserveRecordForm.reserveType == 1 &&
          row.reserveRecordForm.createOperator == this.userinfo.customerId
        );
      };
    },
  },
  async created() {
    this.showSelectBranch = true;
    this.userinfo = JSON.parse(localStorage.getItem("customerInfoList"))[0];
    this.language = localStorage.getItem("language");
  },
  activated() {
    if (!this.branchId) {
      this.showSelectBranch = true;
    }
  },
  destroyed() {},
  methods: {
    async filterBranch(list) {
      this.userinfo = JSON.parse(localStorage.getItem("customerInfoList"))[0];
      const promiseAll = list.map(async (item) => {
        try {
          const res = await this.$logina.post(
            "/api/wxapp/privateroom/getH5ListSelectCondition",
            {
              customerId: this.userinfo.customerId,
              shopId: this.shopId,
              branchId: item.branchId,
            }
          );
          // res
          const resData = res.data;
          const data = resData.data;
          if (data && data.length) return item;
        } catch (error) {
          console.log("error", error);
        }
        return null;
      });
      const newListAll = await Promise.all(promiseAll);
      return newListAll.filter((item) => item);
    },
    async handleSelectSelectBranch(e) {
      this.showSelectBranch = false;
      this.branchId = e.branchId;
      this.branchName = this.language == 'CN' ? e.serverProviderName : e.serverProviderName;
      localStorage.setItem("branchId", e.branchId);
      this.list = [];
      await this.loadOptions();
      await this.loadMealConfigList();
      if (!this.mealConfigList.length) {
        return;
      }
      await this.loadData();
    },
    async loadOptions() {
      const loading = this.$toast.loading({
        message: this.language == "CN" ? "加载中..." : "Loading...",
        forbidClick: true,
        duration: 0,
      });
      try {
        const res = await this.$logina.post(
          "/api/wxapp/privateroom/getH5ListSelectCondition",
          {
            customerId: this.userinfo.customerId,
            shopId: this.shopId,
            branchId: this.branchId,
          }
        );
        console.log("res", res);

        const resData = res.data;
        const data = resData.data;
        this.options = data.map((item) => {
          item.dayText = dayjs(item.dayDate).format("MM-DD");
          // The day of the week, with Sunday as 0
          item.weekText = {
            0: this.language == "CN" ? "周日" : "Sun",
            1: this.language == "CN" ? "周一" : "Mon",
            2: this.language == "CN" ? "周二" : "Tue",
            3: this.language == "CN" ? "周三" : "Wed",
            4: this.language == "CN" ? "周四" : "Thur",
            5: this.language == "CN" ? "周五" : "Fri",
            6: this.language == "CN" ? "周六" : "Sat",
          }[dayjs(item.dayDate).format("d")];
          return item;
        });
        this.isNoData = !data || !data.length;
        if (!data || !data.length) {
          return;
        }
        const lastDate = data[data.length - 1].dayDate;
        this.maxDate = new Date(lastDate);
        this.formData.dayDate = data[0].dayDate;
        this.formData.mealHourId = data[0].mealHourAndRoomGroupList[0].id;
        this.formData.groupId =
          data[0].mealHourAndRoomGroupList[0].groupList[0].id;
      } finally {
        loading.clear();
      }
    },
    // 获取餐段配置
    async loadMealConfigList() {
      const loading = this.$toast.loading({
        message: this.language == "CN" ? "加载中..." : "Loading...",
        forbidClick: true,
        duration: 0,
      });
      try {
        const { data: res } = await this.$logina.get(
          "/api/shopMealHourConfig/getShopMealHourConfig",
          {
            params: {
              shopId: this.shopId,
              branchId: this.branchId,
            },
          }
        );
        this.mealCopyConfigList = res.data;
        console.log(res, this.formData.dayDate, "meal--");
        const datDate = this.formData.dayDate;
        res.data = res.data?.filter((item) => {
          const todayStr = dayjs().format("YYYY-MM-DD HH:mm:ss");
          const endTimeStr = `${datDate} ${item.endTime}`;
          const end = dayjs(endTimeStr, "YYYY-MM-DD HH:mm:ss");
          return end.isAfter(todayStr);
        });
        console.log(res.data, "res.data");
        this.formData.mealHourId = res.data[0].id;
        this.mealConfigList = res.data;
      } finally {
        loading.clear();
      }
    },
    async loadData() {
      const loading = this.$toast.loading({
        message: this.language == "CN" ? "加载中..." : "Loading...",
        forbidClick: true,
        duration: 0,
      });
      try {
        const res = await this.$logina.post("/api/wxapp/privateroom/listForReserve", {
          customerId: this.userinfo.customerId,
          shopId: this.shopId,
          selectDate: this.formData.dayDate,
          mealHourId: this.formData.mealHourId,
          branchId: this.branchId,
          groupId: this.formData.groupId,
        });
        console.log("res", res);
        const resData = res.data;
        const data = resData.data;
        this.list = data;
      } finally {
        loading.clear();
      }
    },
    renderTypeStatusText(value) {
      return (this.groupOptions.find((item) => item.id === value.groupId) || {})
        .name;
    },
    // change handle
    handleChangeDay(item) {
      this.formData.dayDate = item.dayDate;
      // this.formData.mealHourId = item.mealHourAndRoomGroupList[0].id;
      this.formData.groupId = item.mealHourAndRoomGroupList[0].groupList[0].id;
      this.mealConfigList = this.mealCopyConfigList?.filter((mealItem) => {
        const todayStr = dayjs().format("YYYY-MM-DD HH:mm:ss");
        const endTimeStr = `${item.dayDate} ${mealItem.endTime}`;
        const end = dayjs(endTimeStr, "YYYY-MM-DD HH:mm:ss");
        return end.isAfter(todayStr);
      });
      this.formData.mealHourId = this.mealConfigList[0].id;
      this.loadData();
    },
    handleChangeMeal(item) {
      this.formData.mealHourId = item.id;
      // this.formData.groupId = item.groupList[0].id;
      this.loadData();
    },
    handleChangeGroup(item) {
      this.formData.groupId = item.id;
      this.loadData();
    },
    async handleToReserve(value) {
      if (this.cancelReserveShow(value)) {
        await Dialog.confirm({
          title: this.$t("dialogTitle1"),
          message: this.$t("dialogMessage"),
        });
        this.$logina.post("/api/wxapp/privateroomReserve/cancelByCustomer", {
          shopId: localStorage.getItem("shopId"),
          customerId: this.userinfo.customerId,
          id: value.reserveRecordForm?.id,
        }).then(res => {
          console.log(res,'ressssss');
          if (res.data.code === 200) {
            this.$toast.success(this.$t("cancelSuccess"));
            this.loadData();
            return;
          }
        })
        return
       
      }
      if (value.roomStatus !== 1) {
        return;
      }
      sessionStorage.setItem(`reserveInfo_${value.id}`, JSON.stringify(value));
      const meal = this.mealConfigList.find(
        (item) => item.id === this.formData.mealHourId
      );
      sessionStorage.setItem(
        `reserveMeal_${this.formData.mealHourId}`,
        JSON.stringify(meal)
      );
      const group = this.groupOptions.find((item) => item.id === value.groupId);
      sessionStorage.setItem(
        `reserveGroup_${value.groupId}`,
        JSON.stringify(group)
      );
      this.$router.push({
        path: "/location/reserve/order/submit",
        query: {
          shopId: this.shopId,
          branchId: this.branchId,
          dayDate: this.formData.dayDate,
          mealHourId: this.formData.mealHourId,
          reserveId: value.id,
        },
      });
    },
    onPreview(url) {
      ImagePreview([url]);
    },
    handleConfirmSelectCalendar(e) {
      this.$set(this.formData, "dayDate", dayjs(e).format("YYYY-MM-DD"));
      this.showSelectCalendar = false;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.reserve-index {
  font-size: 14px;
  line-height: 1;
  padding-bottom: calc(68px + env(safe-area-inset-bottom));
}

.reserve-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
  user-select: none;

  .branch {
    padding: 16px;
    text-align: center;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #f7f7f7;
    margin-bottom: 8px;
  }

  .reserve-date-counter {
    display: flex;
    // align-items: center;
    align-items: flex-start;
    .calendar-main {
      flex: 1;
      background: #fff;
      height: 49px;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      gap: 3px;
      font-size: 14px;
      color: rgba($color: #000000, $alpha: 0.5);
      // box-shadow: -1px 0 6px rgba(0, 0, 0, 0.2);
      border-bottom: 10px solid #f5f5f5;
    }
  }
  .reserve-date-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 85%;
    overflow-x: auto;
    border-bottom: 10px solid #f5f5f5;

    .reserve-date-item {
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 9px;

      width: calc(100% / 7);
      font-weight: 400;
      color: rgba($color: #000000, $alpha: 0.5);
      position: relative;
      padding-bottom: 12px;
      box-sizing: border-box;

      transition: all 0.2s;

      &.active {
        color: #2186da;

        &::before {
          content: "";
          display: block;
          position: absolute;
          bottom: 0;
          left: 6px;
          right: 6px;
          height: 4px;
          background-color: #2085da;
        }
      }
      .reserve-date-item__week {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
    }
  }

  .reserve-meal-list {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);

    .reserve-meal-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 14px 0;
      gap: 8px;

      font-size: 14px;
      color: #999999;
      transition: all 0.2s;

      .reserve-meal-item__name {
        font-size: 16px;
      }

      &.active {
        color: #2186da;
      }
    }
  }

  .reserve-group-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px;
    box-sizing: border-box;

    .reserve-group-item {
      border-radius: 16px;
      border: 1px solid #d8d8d8;
      padding: 8px 28px;
      box-sizing: border-box;

      font-size: 14px;
      color: #999999;
      transition: all 0.2s;

      &.active {
        background-color: #2186da;
        color: #ffffff;
        border-color: #2085da;
      }
    }
  }
}

.reserve-location-list {
  display: flex;

  flex-direction: column;
  gap: 16px;
  padding: 10px 12px;
  box-sizing: border-box;

  .reserve-location-item {
    box-shadow: 0px 2px 17px 0px rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    position: relative;
    overflow: hidden;

    .reserve-location-item__pic {
      height: 140px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .reserve-location-item__status {
    position: absolute;
    left: 12px;
    top: 12px;
    padding: 5px 20px;

    background: #2085da;
    border-radius: 20px;

    font-size: 10px;
    color: #ffffff;
  }

  .reserve-location-item__desc {
    font-size: 14px;
    color: #666666;
    padding: 0 16px;
  }
  .reserve-location-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;

    .reserve-location-item__name {
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      position: relative;
      padding-right: 12px;
      margin-right: 12px;
      border-right: 1px solid rgba($color: #000000, $alpha: 0.2);

      max-width: 144px;
      line-height: 1.4;
    }

    .reserve-location-item__info {
      flex: 1;
      display: flex;

      font-size: 12px;
      color: #666666;
    }

    .reserve-location-item__action {
      font-size: 16px;
      color: #2085da;

      &.disabled {
        color: #999;
      }
      &.cancel_action {
        color: orange;
      }
    }
  }
}
.empty-comp {
  text-align: center;
  font-size: 16px;
  color: #999;
  margin-top: 50px;
}
</style>
